export enum ThemeColorNames {
    light = 'light',
    dark = 'dark',
    primary = 'primary',
    secondary = 'secondary',
    accent = 'accent',
}
